import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../infrastructure/redux/store';
import { ReactComponent as Logo } from '../../../../infrastructure/assets/images/logo-puc.svg';
import { Container } from '../../shared/components/layout_components/container/styles';

const InicioPage: React.FC = () => {
  const { theme } = useSelector((state: RootState) => state.theme);

  useEffect(() => {
    document.title = 'SisIEC - PUC MG';
  }, []);

  return (
    <Container>
      <Logo fill={theme.colors.textBackground} width={250} />
    </Container>
  );
};

export { InicioPage };
